import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setCloseOutPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useCloseOutSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getCloseOutSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.close_out_page?.close_out_section}`);
      console.log("🚀 ~ getCloseOutSectionJson ~ data:", response);
      console.log("🚀 ~ getCloseOutSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setCloseOutPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Cost Performance section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getCloseOutSectionJson();
  }, [getCloseOutSectionJson]);

  return {
    data,
    loading,
    error,
    getCloseOutSectionJson,
    fetchOnMount,
    refetch: getCloseOutSectionJson
  };
};

export default useCloseOutSection;
